import { createSlice } from "@reduxjs/toolkit";
import {ISubscriberType} from "../../app/subscriberAutoInformation/interface";

export interface IEnum {
  subscriberCategory: string[];
  menuPosition: string[];
  website: string[];
  userRoles: string[];
  siteSettings?: string[];
  userStatus?: string[];
  greeting: string[];
  genders: string[];
  firmType: string[];
  language: string[];
  months: string[];
  years: string[];
  businessPackages: ISubscriberType[];
}

const initialState: IEnum = {
  subscriberCategory: [],
  firmType: [],
  menuPosition: [],
  website: [],
  userRoles: [],
  greeting: [],
  genders: [],
  language: [],
  months: [],
  years: [],
  businessPackages: []
};

export const enumSlice = createSlice({
  name: "enum",
  initialState,
  reducers: {
    setEnums: (state, action) => {
      state = action.payload;
      return state;
    },
  },
});
